import React, { PropTypes, Component } from 'react';
import { connect } from 'react-redux';

import CommentsList from 'components/CommentsList';
import * as actions from 'actions';
import ResourceComment from 'containers/ResourceCommentsList/ResourceComment';
import { getComments, getInfoState, getOldestLiveComment, getCommentsPaging, getCommentsIsLiveListEndReached } from 'selectors';
import { CommentShape } from 'entities';
import Comment from 'components/CommentsList/Comment';
import InfoBar from 'components/InfoBar';
import Button from 'components/Button';
import FlipMove from 'react-flip-move';

class ForumLiveCommentsList extends Component {

  constructor() {
    super();
    this.handleFetchOlderComments = this.handleFetchOlderComments.bind(this);
  }

  componentDidMount() {
    this.props.onDidMount && this.props.onDidMount();
  }

  componentDidUpdate(prevProps) {
    this.props.onDidUpdate && this.props.onDidUpdate(prevProps);
  }

  componentWillUnmount() {
    this.props.onWillUnmount && this.props.onWillUnmount();
  }

  renderComments(comments) {
    return comments.map(comment => {
      return (
        <ResourceComment
          key={comment.id}
          comment={comment}
          canBeRepliedTo={false}
        />
      );
    });
  }

  renderLoadingComments() {
    return [
      <Comment key="loader1" isEmpty />,
      <Comment key="loader2" isEmpty />,
      <Comment key="loader3" isEmpty />
    ];
  }

  handleFetchOlderComments(event) {
    event.preventDefault();
    this.props.onFetchOlderComments && this.props.onFetchOlderComments(this.props.oldestComment);
  }

  render() {
    return (
      <div className>
        {this.props.isSuccessInfoBarVisible &&
          <InfoBar
            type="primary"
            message={this.props.successInfoBarMessage}
            title={this.props.successInfoBarTitle}
            onClose={this.props.onInfoBarClose} />
        }

        <CommentsList
          allowsSorting={false}
          isFollowed={this.props.isFollowed}
          onFollow={this.props.onFollow}
          onUnfollow={this.props.onUnfollow}>
          <FlipMove duration={200} enterAnimation="fade" leaveAnimation="fade">
            {(() => {
              if(this.props.comments.length > 0) {
                return this.renderComments(this.props.comments);
              }
              else {
                return this.renderLoadingComments();
              }
            })()}
          </FlipMove>
        </CommentsList>

        {this.props.canFetchOlderComments &&
          <Button
            onClick={this.handleFetchOlderComments}
            isYellow
            iconType="preloader-dark"
            hasIcon={this.props.isFetchingOlderComments}
            isDisabled={this.props.isFetchingOlderComments}>
            {__('members.comments.loadOlder')}
          </Button>
        }
      </div>
    );
  }
}

ForumLiveCommentsList.propTypes = {
  comments: PropTypes.arrayOf(CommentShape),
  oldestComment: CommentShape,
  isSuccessInfoBarVisible: PropTypes.bool,
  successInfoBarMessage: PropTypes.string,
  isFollowed: PropTypes.bool,
  isFetchingOlderComments: PropTypes.bool,
  canFetchOlderComments: PropTypes.bool,
  successInfoBarTitle: PropTypes.string,
  onDidMount: PropTypes.func,
  onWillUnmount: PropTypes.func,
  onDidUpdate: PropTypes.func,
  onInfoBarClose: PropTypes.func,
  onFollow: PropTypes.func,
  onUnfollow: PropTypes.func,
  onFetchOlderComments: PropTypes.func
};

const mapStateToProps = (state, props) => {
  // The first page of comments comes from the socket when we start watching the thread. Next pages are loaded via the http api.

  const oldestComment = getOldestLiveComment(state);
  const comments = getComments(state, {live: true});
  let isFetchingOlderComments = false;

  if(oldestComment) {
    const query = {
      resourceId: props.forumThread.id,
      resourceType: 'forumThreads',
      dateOffset: oldestComment.approvedAt
    };
    const queryString = JSON.stringify(query);
    const { isFetching } = getCommentsPaging(state, null, { queryString });

    isFetchingOlderComments = isFetching;
  }

  const canFetchOlderComments = comments.length > 0 && !getCommentsIsLiveListEndReached(state);
  const successState = getInfoState(state, 'success');

	return {
    comments,
    isSuccessInfoBarVisible: successState.visible,
    successInfoBarMessage: successState.message,
    successInfoBarTitle: successState.title,
    isFetchingOlderComments,
    canFetchOlderComments,
    oldestComment
  };
};

const mapDispatchToProps = (dispatch, props) => {
  const reset = () => {
    dispatch(actions.infoClose('success'));
    dispatch(actions.forumThreadUnwatch(props.forumThread));
    dispatch(actions.commentsResetLiveList());
    dispatch(actions.commentReset('firstLevel'));
    dispatch(actions.commentEmojisHide('firstLevel'));
  };

  return {
    onDidMount: () => {
      dispatch(actions.forumThreadWatch(props.forumThread));
    },
    onDidUpdate: prevProps => {
      if(prevProps.forumThread.id !== props.forumThread.id) {
        reset();
        dispatch(actions.forumThreadWatch(props.forumThread));
      }
    },
    onWillUnmount: () => {
      reset();
    },
    onInfoBarClose: () => {
      dispatch(actions.infoClose('success'));
    },
    onFetchOlderComments: oldestComment => {
      const query = {
        resourceId: props.forumThread.id,
        resourceType: 'forumThreads',
        dateOffset: oldestComment.approvedAt
      };

      dispatch(actions.commentsFetch(1, process.env.KOOTH_PAGE_SIZE, query, true));
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ForumLiveCommentsList);



/** WEBPACK FOOTER **
 ** ./src/members/Main/Forum/ForumThreadProfile/ForumLiveCommentsList/index.js
 **/